<template>
    <table class="table">
        <tbody>
        <AppointmentsAdminRow
                :appointment="appointment"
                v-for="appointment in appointments"
                v-bind:key="appointment.id"
                @open-partecipants-modal="openPartecipantsModal"
                :in-past="inPast"
        ></AppointmentsAdminRow>
        </tbody>
    </table>
</template>

<script>
import AppointmentsAdminRow from "./AppointmentsAdminRow";

export default {
    name: "AppointmentsAdminTable",
    components: {AppointmentsAdminRow},
    props: {
        appointments: {
            type: Array,
            required: true
        },
        inPast: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        openPartecipantsModal(appointmentId) {
            this.$emit("open-partecipants-modal", appointmentId);
        }
    }
};
</script>
